import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from "../../service/base";
import { CONST_SITE } from '../../utils/common/const';
import HistoryPredictions from 'components/HistoryPredictions';

const navItems = [
    { name: 'Dự đoán', href: '/prediction' },
    { name: 'Thể lệ', href: '/rule' },
    { name: 'Kết quả', href: '/prize-structure' },
];

const Header = () => {
    const location = useLocation();
    const activeNav = location.pathname;
    const [settings, setSettings] = useState({
        link_login: '#',
        link_register: '#',
    });
    const mounted = useRef(false);
    const [isModalHistory, setIsModalHistory] = useState(false);
    const [IP, setIP] = useState('');
    const [FP, setFP] = useState('');
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    // Countdown timer FIFA World Cup 2026
    // 12/06/2026 02:00 GMT+7 = 11/06/2026 19:00 UTC
    useEffect(() => {
      const TARGET_TIME = Date.UTC(2026, 6, 20, 16, 59, 59); // 20/07/2026 23:59:59 GMT+7 = 20/07/2026 16:59:59 UTC

      const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = TARGET_TIME - now;

        if (distance > 0) {
          setCountdown({
            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((distance % (1000 * 60)) / 1000)
          });
        } else {
          setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      };

      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);

      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        mounted.current = true;

        const fetchData = async () => {
            try {
                const res = await getAllSetting({
                    site: CONST_SITE.OK9
                });
                if (mounted.current) {
                    const settingsMap = {};
                    res.data.forEach(item => {
                        settingsMap[item.key] = item.content || '#';
                    });
                    setSettings(settingsMap);
                }
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        };

        fetchData();

        return () => {
            mounted.current = false;
        };
    }, []);

    return (
      <div className="w-full">
        <div
          className="w-full max-w-[1280px] mx-auto rounded-b-[25px]
            flex justify-between items-center  
            bg-white
            py-3 md:py-3
            px-3 md:px-5 lg:px-10"
        >
          <div className="flex justify-start w-full md:w-1/5">
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[33px] w-[82px] md:h-[50px] md:w-auto object-contain"
            />
          </div>
          <div className="flex justify-center items-center w-3/5">
            <div className="md:flex hidden flex-row justify-center items-center w-full gap-5 lg:gap-10">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-center text-[14px] lg:text-[15px] xl:text-[16px] font-semibold ${activeNav === item.href ? 'text-[#36A638] underline' : 'text-gray-500'}`}
                >
                  {item.name}
                </Link>
              ))}
              <button
                onClick={() => setIsModalHistory(true)}
                className={`text-center text-[14px] lg:text-[15px] xl:text-[16px] font-semibold text-gray-500 cursor-pointer bg-transparent border-0`}
              >
                Lịch sử/Nhận Thưởng
              </button>
            </div>
          </div>
          <div className="flex justify-end w-full md:w-1/5">
            <div className="flex flex-row justify-end items-center gap-[6px] w-full">
              <Link
                to={settings.link_login}
                target="_blank"
                className="times-new-roman-force flex h-[32px] md:h-[36px] w-[93px] md:w-[125px] shrink-0 items-center justify-center rounded-[15.682px] md:rounded-[80px] bg-white px-1 sm:px-2 md:px-4 text-center font-roboto font-['Times_New_Roman'] text-[12px] md:text-[14px] font-semibold md:font-bold leading-normal md:leading-[20px] tracking-normal md:tracking-[0.28px] text-[#31A749]"
                style={{
                  border: '1px solid #36A638',
                  boxShadow: 'inset 0 0 0 1px #36A638'
                }}
              >
                ĐĂNG NHẬP
              </Link>
              <Link
                to={settings.link_register}
                target="_blank"
                className="times-new-roman-force flex h-[32px] md:h-[36px] w-[93px] md:w-[125px] shrink-0 items-center justify-center rounded-[27.273px] md:rounded-[80px] border border-[#F4F4F4] bg-[#31A749] px-1 sm:px-2 md:px-4 text-center font-roboto font-['Times_New_Roman'] text-[12px] md:text-[14px] font-semibold md:font-bold leading-normal md:leading-[20px] tracking-normal md:tracking-[0.28px] text-white shadow-[inset_0px_0px_3px_0px_#056515] md:shadow-[0px_0px_2.727px_0px_#34A447,inset_0px_0px_13.636px_0px_#056515]"
              >
                ĐĂNG KÝ
              </Link>
            </div>
          </div>
        </div>
        <div className="w-full px-2">
          <div className="hidden relative bg-[#50C021]/5 flex flex-row items-center justify-between gap-0 md:gap-4 lg:gap-6 mt-3 md:mt-5 border-[2.6px] border-solid border-white rounded-[15px] md:rounded-[20px] px-2 md:px-6 lg:px-10 h-[80px] sm:h-[90px] sm:h-[80px] lg:h-[110px]">
            {/* Left side - FIFA World Cup Logo */}
            <img
              src="/assets/images/fifacountdown/left.png"
              alt="FIFA World Cup 2026"
              className="w-auto h-full object-contain flex-shrink-0 md:block hidden"
            />
            <img
              src="/assets/images/fifacountdown/leftmb.png"
              alt="FIFA World Cup 2026"
              className="w-auto h-full object-contain flex-shrink-0 md:hidden block"
            />

            {/* Right side - Countdown Timer */}
            <div className="flex flex-row items-center justify-center md:justify-end gap-1.5 sm:gap-2 md:gap-3 lg:gap-4 h-[60px] sm:h-[80px] w-full md:w-auto ml-[-70px] sm:!ml-0">
              {/* Days - Green */}
              <div className="flex flex-col items-center justify-center rounded-lg min-w-[35px] sm:min-w-[50px] md:min-w-[55px] xl:min-w-[80px] ">
                <div
                  className="flex justify-center items-center rounded-[8px] md:rounded-[10px] text-white text-[12px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[28px] w-full font-bold leading-tight py-1"
                  style={{
                    background: 'linear-gradient(270deg, #009631 0%, #50C021 50%, #009631 100%)'
                  }}
                >
                  {countdown.days}
                </div>
                <div className="text-[#36A638] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px] font-semibold uppercase mt-0.5 md:mt-1">
                  NGÀY
                </div>
              </div>

              {/* Hours - Red */}
              <div className="flex flex-col items-center justify-center rounded-lg min-w-[35px] sm:min-w-[50px] md:min-w-[55px] xl:min-w-[80px] ">
                <div
                  className="flex justify-center items-center rounded-[8px] md:rounded-[10px] text-white text-[12px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[28px] w-full font-bold leading-tight py-1"
                  style={{
                    background: 'linear-gradient(270deg, #EC1C23 0%, #FF555A 50%, #EC1C23 100%)'
                  }}
                >
                  {countdown.hours}
                </div>
                <div className="text-[#EF4444] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px] font-semibold uppercase mt-0.5 md:mt-1">
                  GIỜ
                </div>
              </div>

              {/* Minutes - Blue */}
              <div className="flex flex-col items-center justify-center rounded-lg min-w-[35px] sm:min-w-[50px] md:min-w-[55px] xl:min-w-[80px] ">
                <div
                  className="flex justify-center items-center rounded-[7px] md:rounded-[8.295px] text-white text-[12px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[28px] w-full font-bold leading-tight py-1"
                  style={{
                    background: 'linear-gradient(270deg, #2D3092 0%, #383DC7 50%, #2D3092 100%)'
                  }}
                >
                  {countdown.minutes}
                </div>
                <div className="text-[#383DC7] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px] font-semibold uppercase mt-0.5 md:mt-1">
                  PHÚT
                </div>
              </div>

              {/* Seconds - Grey */}
              <div className="flex flex-col items-center justify-center rounded-lg min-w-[35px] sm:min-w-[50px] md:min-w-[55px] xl:min-w-[80px] ">
                <div
                  className="flex justify-center items-center rounded-[7px] md:rounded-[8.295px] text-white text-[12px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[28px] w-full font-bold leading-tight py-1"
                  style={{
                    background: 'linear-gradient(270deg, #404040 0%, #727272 50%, #404040 100%)'
                  }}
                >
                  {countdown.seconds}
                </div>
                <div className="text-[#404040] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px] font-semibold uppercase mt-0.5 md:mt-1">
                  GIÂY
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full max-w-2xl mx-auto h-auto flex justify-center items-center md:px-10 px-5">
          <img
            src="/assets/images/header/bannerpc.png"
            alt=""
            className="w-full max-w-[800px] h-auto object-contain py-2 md:flex hidden"
          />
          <img
            src="/assets/images/header/bannermb.png"
            alt=""
            className="w-full max-w-[75%] h-auto object-contain py-2 md:hidden flex"
          />
        </div>

        <div className="flex justify-center items-center w-full px-2 mb-3">
          <div
            className="md:hidden flex flex-row items-stretch w-full gap-1 py-1.5 px-1 rounded-[999px] bg-[#F4FFF5] border border-[#CDEDD2]"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
              boxShadow: '0px 2px 8px rgba(43, 133, 45, 0.1)'
            }}
          >
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`flex flex-1 items-center justify-center rounded-[999px] px-1 py-1 text-center text-[13px] sm:text-[14px] font-bold tracking-[0.15px] leading-[18px] transition-all duration-200 ${
                  activeNav === item.href
                    ? 'bg-[#36A638] text-white shadow-[inset_0px_0px_0px_1px_#2B852D]'
                    : 'text-[#6C7A70]'
                }`}
                style={{ fontFamily: "'Times New Roman', Times, serif" }}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => setIsModalHistory(true)}
              className="flex flex-1 items-center justify-center rounded-[999px] px-1 py-1 text-center text-[13px] sm:text-[14px] font-bold tracking-[0.15px] leading-[18px] text-[#6C7A70] cursor-pointer bg-transparent border-0"
              style={{ fontFamily: "'Times New Roman', Times, serif" }}
            >
              Lịch sử/Nhận Thưởng
            </button>
          </div>
        </div>

        <HistoryPredictions
          isModalVote={isModalHistory}
          setIsModalVote={setIsModalHistory}
          IP={IP}
          FP={FP}
        />
      </div>
    );
}

export default Header;
